/* eslint-disable jsx-a11y/anchor-is-valid */
import { CloseCircleFilled } from '@ant-design/icons';
import { Table, Input, Select } from 'antd';
import { billingSelectors, workSpaceSelectors } from 'containers/App/selectors';
import { useMemo, useRef } from 'react';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import ModalPatient from '../../../pages/BillingProcessRegister/RegisterFirstStep/ModalPatient';
import { hospital_visit_and_links_results } from '../../../types/hospitalVisitRecord';

type Props = {
  data: hospital_visit_and_links_results[];
  onChangeData: any;
  handleRemoveHospital: (row: hospital_visit_and_links_results, index: number) => Promise<void> | void;
  fieldHospital?: any[];
  page: number;
};

const checkHospitalVisit = (text: string, options: any[]) => {
  const find = options.find((f) => f.value === text);

  if (find) {
    return find.display_id;
  }
  return '';
};

const TableBillingFirstStep: FC<Props> = ({ data, onChangeData, fieldHospital, page, handleRemoveHospital }) => {
  const { statusBill } = useSelector(workSpaceSelectors);
  const { itemInvoice } = useSelector(billingSelectors);

  const ref: any = useRef(null);
  const hospitalVisitOption = useMemo(() => {
    const result = fieldHospital?.find(([_key, value]: [string, any]) => value.display_id === 'hospital_visit');
    if (!result) {
      return [];
    }
    return result[1].options;
  }, [fieldHospital]);

  const billingTypeOption = useMemo(() => {
    const result = fieldHospital?.find(([_key, value]: [string, any]) => value.display_id === 'billing_type');
    if (!result) {
      return [];
    }
    return result[1].options;
  }, [fieldHospital]);

  return (
    <div>
      <Table
        columns={[
          {
            title: '',
            width: '5%',
            align: 'center',
            render(text: string, row, index: number) {
              return {
                props: {
                  style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'center' },
                  className: 'standardFont',
                },
                children: <div>{(page - 1) * 50 + index + 1}</div>,
              };
            },
          },
          {
            title: 'ID',
            dataIndex: 'patient_id',
            key: 'patient_id',
            width: '8%',
            align: 'center',
            render(text: string) {
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: 'ご利用者名',
            dataIndex: 'patient_name',
            key: 'patient_name',
            width: '15%',
            align: 'center',
            render(text) {
              return {
                props: {
                  style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: '受診 XO',
            key: 'hospital_visit',
            dataIndex: 'hospital_visit',
            width: '10%',
            align: 'center',
            render(text: string, row: hospital_visit_and_links_results, index: number) {
              let visitType = checkHospitalVisit(text, hospitalVisitOption);
              const billingType = billingTypeOption.find((f: any) => f.value === row.billing_type);

              return {
                props: {
                  style: { textAlign: 'center' },
                  className: 'standardFont',
                },
                children:
                  (billingType && billingType.display_id === 'o_advance_payment') ||
                  (statusBill && statusBill.value === itemInvoice?.invoice_month) ? (
                    <div style={{ display: 'flex', justifyContent: 'space-around', cursor: 'not-allowed' }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        {' '}
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                          fill={visitType === 'o_yes' ? 'black' : '#D8D8D8'}
                        />{' '}
                      </svg>
                      <div style={{ position: 'relative' }}>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect
                            x="0.1875"
                            y="3.1687"
                            width="4.4812"
                            height="26.8872"
                            transform="rotate(-45 0.1875 3.1687)"
                            fill={visitType === 'o_no' ? 'black' : '#D8D8D8'}
                          />
                        </svg>
                        <svg
                          style={{ position: 'absolute', left: 0 }}
                          width="23"
                          height="23"
                          viewBox="0 0 23 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="19.0117"
                            width="4.4812"
                            height="26.8872"
                            transform="rotate(45 19.0117 0)"
                            fill={visitType === 'o_no' ? 'black' : '#D8D8D8'}
                          />
                        </svg>
                      </div>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                      <svg
                        onClick={() => onChangeData('o_yes', row, 'hospital_visit', index)}
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {' '}
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                          fill={visitType === 'o_yes' ? 'black' : '#D8D8D8'}
                        />{' '}
                      </svg>
                      <svg
                        onClick={() => onChangeData('o_no', row, 'hospital_visit', index)}
                        width="24"
                        height="24"
                        viewBox="0 0 23 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.1875"
                          y="3.1687"
                          width="4.4812"
                          height="26.8872"
                          transform="rotate(-45 0.1875 3.1687)"
                          fill={visitType === 'o_no' ? 'black' : '#D8D8D8'}
                        />
                        <rect
                          x="19.0117"
                          width="4.4812"
                          height="26.8872"
                          transform="rotate(45 19.0117 0)"
                          fill={visitType === 'o_no' ? 'black' : '#D8D8D8'}
                        />
                      </svg>
                    </div>
                  ),
              };
            },
          },
          {
            title: '請求設定',
            width: '10%',
            align: 'center',
            dataIndex: 'billing_type',
            render(text: string, row: any, index: number) {
              let hospitalVisit = checkHospitalVisit(row.hospital_visit, hospitalVisitOption);
              const dispayId = billingTypeOption.find((f: any) => f.value === text);
              const options = !hospitalVisit ? [] : hospitalVisit === 'o_yes' ? optionYes : optionNo;
              const value = options.length < 1 ? { value: '' } : options.find((f) => f.value === dispayId?.display_id);
              return {
                props: {
                  style: {
                    borderLeft: '2px solid rgba(246, 246, 246, 1)',
                    textAlign: 'center',
                    padding: '0px',
                  },
                  className: 'standardFont',
                },
                children: (
                  <div>
                    <Select
                      disabled={
                        (dispayId && dispayId.display_id === 'o_advance_payment') ||
                        (statusBill && statusBill.value === itemInvoice?.invoice_month)
                      }
                      value={value?.value}
                      style={{ width: '100%', height: '100%' }}
                      onChange={(e) => onChangeData(e, row, 'billing_type', index)}
                    >
                      {options.map((v) => (
                        <Select.Option key={v.value} value={v.value}>
                          {v.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                ),
              };
            },
          },
          {
            title: '取消',
            width: '5%',
            align: 'center',
            dataIndex: 'remove',
            render(_: string, row: hospital_visit_and_links_results, index: number) {
              return (
                <CloseCircleFilled
                  style={{
                    fontSize: 20,
                    color: '#a7a7a7',
                    cursor: statusBill && statusBill.value === itemInvoice?.invoice_month ? 'no-drop' : 'pointer',
                  }}
                  onClick={() => {
                    if (statusBill && statusBill.value === itemInvoice?.invoice_month) return;
                    handleRemoveHospital(row, index);
                  }}
                />
              );
            },
          },
          {
            title: '備考',
            key: 'hospital_visit_remark',
            dataIndex: 'hospital_visit_remark',
            width: '40%',
            align: 'center',
            render(text: string, row: any, index: number) {
              const billingType = billingTypeOption.find((f: any) => f.value === row.billing_type);
              return {
                props: {
                  style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left', padding: '0px' },
                  className: 'standardFont',
                },
                children: (
                  <div>
                    <Input
                      size="large"
                      value={text}
                      onChange={(e) => onChangeData(e.target.value, row, 'hospital_visit_remark', index)}
                      style={{ height: '60px' }}
                      disabled={
                        (billingType && billingType.display_id === 'o_advance_payment') ||
                        (statusBill && statusBill.value === itemInvoice?.invoice_month)
                      }
                    />
                  </div>
                ),
              };
            },
          },
          {
            title: '',
            dataIndex: 'cpap_id',
            width: '7%',
            align: 'center',
            render(text: string, row, _index) {
              return {
                props: {
                  style: { background: '#ff8a00', textAlign: 'center' },
                  className: 'standardFont',
                },
                children: (
                  <a
                    className="smallBoldFont"
                    style={{ color: 'white' }}
                    onClick={() => {
                      ref.current.openModal(row.item_ref?.cpap_id.i_id, row.patient_name);
                    }}
                  >
                    表示
                  </a>
                ),
              };
            },
          },
        ]}
        dataSource={data}
        pagination={false}
      />
      <ModalPatient ref={ref} />
    </div>
  );
};
export default TableBillingFirstStep;

const optionYes = [
  {
    value: 'o_normal',
    name: '通常（指定なし）',
  },
  {
    value: 'o_normal_past_no_claim',
    name: '通常（未受診分の請求不要）',
  },
  {
    value: 'o_no_claim',
    name: '請求不要',
  },
];

const optionNo = [
  {
    value: 'o_unpaid',
    name: '通常（指定なし）',
  },
  {
    value: 'o_no_claim',
    name: '請求不要',
  },
  {
    value: 'o_no_claim_for_period',
    name: '請求不要（未受診分の請求不要）',
  },
];
